import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/domains';
import { AttendeeSubmission } from '../../../domain';
export var GET_ATTENDEE_SUBMISSIONS_USE_CASE = 'GET_ATTENDEE_SUBMISSIONS_USE_CASE';
export var GetAttendeeSubmissionsUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(GetAttendeeSubmissionsUseCase, _UseCase);

  var _super = _createSuper(GetAttendeeSubmissionsUseCase);

  function GetAttendeeSubmissionsUseCase(assignmentRepository, submissionRepository, questionReleasesRepository) {
    var _this;

    _classCallCheck(this, GetAttendeeSubmissionsUseCase);

    _this = _super.call(this);
    _this.assignmentRepository = assignmentRepository;
    _this.submissionRepository = submissionRepository;
    _this.questionReleasesRepository = questionReleasesRepository;
    return _this;
  }

  _createClass(GetAttendeeSubmissionsUseCase, [{
    key: "validate",
    value: function validate(queryParams) {
      var collection = [{
        argument: queryParams.assignmentId,
        argumentName: 'Assignment Id'
      }, {
        argument: queryParams.attendeeId,
        argumentName: 'Attendee Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
        var resultOrError, submissionsResponse, submissionsByAssignmentId, assignmentSummaryResponse, assignmentSummary, questionReleaseResponse, questionRelease, attendeeSubmissionResponse, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(queryParams);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                _context.next = 5;
                return this.submissionRepository.getMany(queryParams);

              case 5:
                submissionsResponse = _context.sent;
                submissionsByAssignmentId = submissionsResponse.getValue(); // get assignment summary

                _context.next = 9;
                return this.assignmentRepository.getById(queryParams.assignmentId);

              case 9:
                assignmentSummaryResponse = _context.sent;
                assignmentSummary = assignmentSummaryResponse.getValue(); // TODO: Need to review this code, because it's cause duplicate api called
                // get questions release by formReleaseId

                _context.next = 13;
                return this.questionReleasesRepository.get({
                  formReleaseId: assignmentSummary.formReleaseInformation.id,
                  hasCorrectAnswer: true,
                  showExplanation: true
                });

              case 13:
                questionReleaseResponse = _context.sent;
                questionRelease = questionReleaseResponse.getValue(); // combine assignment summary to submissions

                attendeeSubmissionResponse = {
                  title: assignmentSummary.title,
                  submissions: submissionsByAssignmentId,
                  totalQuestions: questionRelease.length,
                  attendeeId: queryParams.attendeeId
                };
                result = AttendeeSubmission.fromJson(attendeeSubmissionResponse);
                return _context.abrupt("return", Result.ok(result.getValue()));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return GetAttendeeSubmissionsUseCase;
}(UseCase);